export const DAY_START_TIME = '02:00:00'
